import React, {Fragment} from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import {connect} from "src/store";
import TextInput from "../../form/TextInput";
import Select from "../../form/Select";


class PodcastHostForm extends React.Component<any, object> {


    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<object>, snapshot?: any) {
    if (prevProps.values[prevProps.componentConfig.idfield] !== this.props.values[this.props.componentConfig.idfield]) {
    this.setState({events: []});
}
}

render() {
    console.log(this.props);
    return (
        <Fragment>
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-md-5">
                        <TextInput
                            {...this.props.getFieldProps("url")}
                            name="url"
                            value={this.props.values.url}
                            label="Url"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-5">
                        <Select
                            name="host"
                            optionname="MediaProvider"
                            objectValue={false}
                            storeType="local"
                            label="Szociális média"
                            value={this.props.values.host}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
            </form>
        </Fragment>
    );
}
}

export default connect((state) => {
    return {
        partner: state.app.context.partner
    }
})(createForm(PodcastHostForm));
